import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getAccountScopeUserSettings } from "owa-session-store";
import { isOcpsPolicyEnabled, isUserAllowedToChangeSettings, KeyboardStylesPolicySettingId, OcpsPolicyFeature, } from "owa-owsprime-policies-store";
import { toggleLocalKeytipsEnabledStatusMutator } from "../mutators/toggleLocalKeytipsEnabledStatus";

export const initializeKeytipsEnabledStatus = (): void => {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    
    // Check the policy first. When the admin disallows user override, force the EnableKeytips
    // policy value (default enabled) without reading the user's stored preference at all. When
    // no OCPS policy applies, isUserAllowedToChangeSettings returns true, so we fall through to
    // the user preference below.
    if (!isUserAllowedToChangeSettings(OcpsPolicyFeature.KeyboardStyles, mailboxInfo)) {
        toggleLocalKeytipsEnabledStatusMutator(isOcpsPolicyEnabled(KeyboardStylesPolicySettingId.EnableKeytips, mailboxInfo, true /* enabledIfUndefined */));
        return;
    }
    
    // User changes are allowed (or no policy applies): the stored preference wins.
    const primeSettings = getAccountScopeUserSettings(mailboxInfo)?.PrimeSettings;
    const keytipsSettings = primeSettings?.Items?.filter(item => item.Id === "Ribbon_ShowKeytips").map(item => item.Value?.[0]?.value)[0];
    
    if (keytipsSettings != undefined) {
        toggleLocalKeytipsEnabledStatusMutator(keytipsSettings === "true");
        return;
    }
    
    // No stored preference: seed from the EnableKeytips policy value, which resolves to the app
    // default of "enabled" when no policy applies.
    toggleLocalKeytipsEnabledStatusMutator(isOcpsPolicyEnabled(KeyboardStylesPolicySettingId.EnableKeytips, mailboxInfo, true /* enabledIfUndefined */));
};
